function n(a) {
  if (a === null || a === !0 || a === !1)
    return NaN;
  var e = Number(a);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
export {
  n as default
};
